import React from "react";

/**
 * The session learning switch: one chip with a state dot, on by default for every session. Used in the diagnosis popover header
 * beside the exit button. It shows the confirmed state, a spinner while the server applies a change, and is disabled while a
 * turn runs (a change then would end that turn on screen).
 */
const TITLE_PENDING = "Applying…";
const TITLE_NO_SESSION = "Available once the session has started.";
const TITLE_BUSY = "Wait for the answer to finish, then change learning.";
const TITLE_ON = "Learning is on for this session: scores use past conversations and a conversation marked improved is kept. Click to turn it off.";
const TITLE_OFF = "Learning is off for this session: scores come from the guide only and nothing is stored. Click to turn it on.";

export default function LearningSwitch({ enabled = true, pending = false, busy = false, hasSession = true, onToggle }) {
  const title = pending ? TITLE_PENDING : !hasSession ? TITLE_NO_SESSION : busy ? TITLE_BUSY : enabled ? TITLE_ON : TITLE_OFF;
  return (
    <button
      type="button"
      role="switch"
      aria-label="Session learning"
      aria-checked={enabled}
      aria-busy={pending || undefined}
      disabled={pending || busy || !hasSession}
      className={`d5-learning-toggle${enabled ? " is-on" : " is-off"}${pending ? " is-pending" : ""}`}
      title={title}
      onClick={() => onToggle?.(!enabled)}
    >
      <span className="d5-learning-toggle-dot" aria-hidden="true" />
      <span className="d5-learning-toggle-text">{enabled ? "Learning on" : "Learning off"}</span>
    </button>
  );
}
